var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import currentUserDetailsReducersMapObject from "@ane/exp-data/lib/userDetails/CurrentUserDetailsReducer";
import getWorkspaceReducersMapObject from "@ane/exp-ux/lib/components/GetWorkspace/GetWorkspace.ducks";
import UserAccessReducersMapObject from "@ane/exp-ux/lib/components/GetUserAccess/UserAccess.reducer";
import { combineReducers } from "redux";
import "./views/GarView/ducks/index.js";
import RouteUpdateState from "@ane/core/lib/services/syncUrlAndStore/RouteUpdateReducer";
import { performanceReducer } from "./views/GarView/actions/GarLogPeformanceReducer.js";
import { AnalysisStudyListReducer } from "./views/Analysis/Analysis/ducks/AnalysisStudyListReducer.js";
import { AnalysisStudyLogPerformanceReducer } from "./views/Analysis/Analysis/ducks/AnalysisStudyLogPerformanceReducer.js";
import { AnalysisStudyListReducer as AnalysisStudyListReducer$1 } from "./views/Analysis/_shouldbeincore/ducks/DialogServiceReducer.js";
import "./views/Analysis/AnalysisCreate/ducks/AnalysisCreate.ducks.js";
import { AnalysisTaskReducer } from "./views/Analysis/Analysis/ducks/AnalysisTaskReducer.js";
import { analysisEditReducer } from "./views/Analysis/Analysis/components/AnalysisEdit/AnalysisEdit.ducks.js";
import SetSubscribersReducersMapObject from "@ane/exp-ux/lib/components/Subscribers/SetSubscribers.ducks";
import { reducer } from "./views/GarView/ducks/Gar.ducks.js";
import { analysisCreateReducer } from "./views/Analysis/AnalysisCreate/components/AnalysisCreateContainer/AnalysisCreateContainer.ducks.js";
const garModuleReducer = __spreadProps(__spreadValues(__spreadProps(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, currentUserDetailsReducersMapObject), getWorkspaceReducersMapObject), UserAccessReducersMapObject), RouteUpdateState), {
  gar: combineReducers({
    GARModule: reducer,
    GARPerformance: performanceReducer
  })
}), SetSubscribersReducersMapObject), {
  analysisStudyList: AnalysisStudyListReducer,
  dialogService: AnalysisStudyListReducer$1,
  analysisStudyLogPerformanceReducer: AnalysisStudyLogPerformanceReducer,
  analysisCreate: analysisCreateReducer,
  analysisTask: AnalysisTaskReducer,
  analysisEdit: analysisEditReducer
});
export {
  garModuleReducer as default,
  garModuleReducer
};
//# sourceMappingURL=reducers.js.map
